import { hexToRgbA, getDarkenColor } from './'

export default (type, colors) => {
  const styles = {
    default: {
      'rich-page-header__bg': {
        customCSS: `
          .rich-page-header__bg:after {
            background: ${hexToRgbA(colors.primary, 0.8)};
          }
        `
      },
      'rich-page-header': {
        background: colors.secondary
      }
    },
    type1: {
      'rich-page-header': {
        position: 'relative',
        overflow: 'hidden',
        zIndex: '0',
        background: colors.light
      },
      'rich-page-header__bg__title': {
        textAlign: 'center',
        color: colors.light,
        lineHeight: '126%',
        textTransform: 'capitalize',
        paddingBottom: '6px',
        marginTop: '25px',
      },
      'rich-page-header__title': {
        fontFamily: 'Helvetica-Neue-LT-Std',
        fontWeight: 'bold',
        position: 'relative',
        marginBottom: 0,
        fontSize: '33px',
        textShadow: 'none',
        color: colors.secondary,
        customCSS: `
          .rich-page-header__title:after {
            display: none;
          }
        `
      },
      'rich-page-header__subtitle': {
        textAlign: 'center',
        marginTop: 0,
        fontSize: '24px',
        lineHeight: '126%',
        color: colors.light,
        customCSS: `
          .rich-page-header__subtitle.inverse a {
            color: ${colors.dark}
          }
        `
      },
      'rich-page-header__bg': {
        customCSS: `
          .rich-page-header__bg:after {
            background: ${hexToRgbA(colors.dark, 0.5)};
          }
        `
      },
      'rich-page-header__content': {
        position: 'relative',
        color: colors.light,
        textAlign: 'left',
        paddingTop: '25px',
        textShadow: 'none',
        customCSS: `
          .rich-page-header.state-has-overlap + .c-tabs--pagey {
            margin-top: -84px;
          }
          .rich-page-header__content a {
            color: ${colors.light};
            background-image:none !important;
            text-shadow:none !important;
          }
          .rich-page-header__content a:hover,
          .rich-page-header__content a:active,
          .rich-page-header__content a:focus {
            color: ${getDarkenColor(colors.light, 0.1)};
          }
          @media screen and (min-width: 32em) {
            .rich-page-header__content {
              padding-top: 25px!important;
              padding-bottom: 0px;
            }
          }
          @media screen and (min-width: 48em) {
            .rich-page-header__content {
              padding-top: 35px!important;
              padding-bottom: 0px;
            }
          }
        `
      },
      'rich-page-header__content--centered': {
        textAlign: 'center',
        paddingBottom: '3rem'
      },
      'rich-page-header__content__row': {
        maxWidth: 'none',
        padding: '0px 40px',
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/richPageHeader.js